import React, { useState, useEffect } from "react";
import { Alert } from "antd";
import { useTranslation } from "react-i18next";
import { SelectList } from "./components/SelectList/SelectList";
import { TableComponent } from "./components/TableComponent/TableComponent";
import { MapComponent } from "./components/MapComponent/MapComponent";
import request from "utils/request";
import { isForbiddenError } from "utils/requestHelpers";

export const RouteSchedule = () => {
  const { t } = useTranslation();
  const [isAccessDenied, setIsAccessDenied] = useState(false);
  const [tableData, setTableData] = useState({
    data: [],
    filteredData: [],
  });
  const [transportersData, setTransportersData] = useState({
    data: [],
    searchData: [],
  });
  const [settlementsData, setSettlementsData] = useState({
    data: [],
    searchData: [],
  });

  const requestTable = async () => {
    const result = await request("/route-schedule", { handleForbidden: true });
    setTableData((prev) => ({
      ...prev,
      data: result,
      filteredData: result,
    }));
  };
  const requestTransporters = async () => {
    const result = await request("/transporter", { handleForbidden: true });
    setTransportersData((prev) => ({
      ...prev,
      data: result,
      searchData: result,
    }));
  };
  const requestSettlement = async () => {
    const result = await request("/settlement", { handleForbidden: true });
    setSettlementsData((prev) => ({
      ...prev,
      data: result,
      searchData: result,
    }));
  };

  useEffect(() => {
    const handleError = (err) => {
      if (isForbiddenError(err)) setIsAccessDenied(true);
    };
    requestTable().catch(handleError);
    requestTransporters().catch(handleError);
    requestSettlement().catch(handleError);
  }, []);

  if (isAccessDenied) {
    return (
      <Alert
        type="error"
        message={t("error.doNotHaveAccessToViewThisModule")}
        showIcon
      />
    );
  }

  return (
    <div>
      <SelectList
        transportersData={transportersData}
        setTransportersData={setTransportersData}
        settlementsData={settlementsData}
        setSettlementsData={setSettlementsData}
        tableData={tableData}
        setTableData={setTableData}
      />
      <TableComponent tableData={tableData} />
      {tableData.filteredData.length !== 0 && (
        <MapComponent tableData={tableData} />
      )}
    </div>
  );
};
